import { ValueOf } from '~/types/value-of'

import type { CoinModel } from './model/coin.model'

export const transactionType = {
  ALL: 'all',
  GENESIS: 'genesis_transaction',
  BLOCK_METADATA: 'block_metadata_transaction',
  USER: 'user_transaction',
  STATE_CHECKPOINT: 'state_checkpoint_transaction',
  VALIDATOR_TRANSACTION: 'validator_transaction',
  PENDING: 'pending_transaction',
} as const

export type transactionType = ValueOf<typeof transactionType>;

export interface ITransactionFilterParam {
  startAmount?: number
  endAmount?: number
  functionName?: string
  coin?: CoinModel
  startTime?: number
  endTime?: number
  type?: Array<transactionType>
  from?: string
  to?: string
}

export interface ITransactionParam extends ITransactionFilterParam {
  size: number
  trxType: transactionType
  lastVal?: string
}